// @flow

import { createContext } from 'react';

import type { Role } from './types';

export type Context = {
  orgId?: string,
  role?: Role,
};

export default (createContext({
  orgId: undefined,
  role: undefined,
}): React.Context<Context>);
